class MassiveSmartGeocodeModel extends App.Models.BaseModel {
    modelUrl = 'MassiveSmartGeocode';

    fetchWithCriteria = (obj) => {
        return Monet.Model.fetchWithCriteria({
            options: obj,
            model: this
        });
    }
}

App.Models.MassiveSmartGeocode = MassiveSmartGeocodeModel;